import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { ToppingModel } from "../../infrastructure/model/ProductItemModel";

interface AppToppingContextType {
  toppings: ToppingModel[];
  setToppings: React.Dispatch<React.SetStateAction<ToppingModel[]>>;
}

const AppToppingContext = createContext<AppToppingContextType | undefined>(undefined);

export const AppToppingProvider = ({ children }: { children: ReactNode }) => {
  const [toppings, setToppings] = useState<ToppingModel[]>([]);
  return (
    <AppToppingContext.Provider value={{ toppings, setToppings }}>{children}</AppToppingContext.Provider>
  );
};

export const useToppingContext = (): AppToppingContextType => {
  const context = useContext(AppToppingContext);
  if (!context) {
    console.error("useToppingContext must be used within an AppToppingsProvider");
    return {} as AppToppingContextType;
  }
  return context;
};
